module.exports = __webpack_public_path__ + "static/media/smile.eb5628cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smile.png
// module id = 996
// module chunks = 0